import { PriceListItemDetail } from "@legacy-megarax/crm-contracts";
import { useValidatorForm } from "@legacy-megarax/react-client";
import { AsyncButton, DateTimeInput, DecimalInput, SwitchInput, TextInput } from "@legacy-megarax/ui-components";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Decimal from "decimal.js";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom-v5-compat";

import { formValidator, getErrorMessage, InitialProposeEditInput, ProposeEditInput } from "./proposeEditForm";

interface Props {
  item: PriceListItemDetail;
  onProposeEdit: (input: ProposeEditInput) => Promise<void>;
}

export const ProposeEditDialog: React.FC<Props> = ({ onProposeEdit, item }) => {
  const navigate = useNavigate();

  const classes = useStyles();
  const [activeImmediately, setActiveImmidiately] = useState<boolean>(true);
  const { formValue, onFormInput, onSubmit, formErrors } = useValidatorForm(
    {
      activeFrom: item.current?.activeFrom ?? null,
      netPrice: item.current?.netPrice ?? new Decimal(0),
      comment: "",
    } as InitialProposeEditInput,
    formValidator,
    onProposeEdit,
  );
  const lastDate = useRef(formValue.activeFrom);

  const onClose = () => navigate(-1);

  useEffect(() => {
    if (activeImmediately) return onFormInput("activeFrom")(null);
    return onFormInput("activeFrom")(lastDate.current);
  }, [activeImmediately]);

  useEffect(() => {
    if (formValue.activeFrom) lastDate.current = formValue.activeFrom;
  }, [formValue.activeFrom]);

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Propozycja zmiany</DialogTitle>
      <DialogContent className={classes.container}>
        <SwitchInput setValue={setActiveImmidiately} value={activeImmediately} label="Aktywna od razu?" />
        <DateTimeInput
          label={`Aktywna od ${activeImmediately ? "razu" : ""}`}
          inputVariant="outlined"
          value={formValue.activeFrom}
          onChange={onFormInput("activeFrom")}
          error={getErrorMessage(formErrors.activeFrom)}
          minDate={new Date()}
          ampm={false}
          disabled={activeImmediately}
        />
        <DecimalInput
          label={"Cena netto"}
          variant="outlined"
          value={formValue.netPrice}
          onChange={onFormInput("netPrice")}
          error={getErrorMessage(formErrors.netPrice)}
        />
        <TextInput
          label={"Komentarz"}
          variant="outlined"
          value={formValue.comment}
          onChange={onFormInput("comment")}
          multiline
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anuluj</Button>
        <AsyncButton color="primary" asyncAction={onSubmit}>
          Utwórz
        </AsyncButton>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles((theme) => {
  return {
    actions: {
      justifyContent: "space-between",
    },
    container: {
      marginTop: theme.spacing(2),
      display: "flex",
      flexDirection: "column",
      "& > .MuiFormControl-root": {
        margin: theme.spacing(1, 0),
      },
    },
  };
});
